<template>
  <div>
    <div class="container mb-48">
      <AccountWidget />
      <div class="bg-gray rounded-t-md shadow relative z-50 mt-2 py-1 pb-4 sm:pb-8 md:pb-16 rounded-b-md">
        <div class="text-center relative">
          <button
            class="absolute top-0 left-0 ml-6 mt-1 hover-animate"
            @click="$router.go(-1)"
          >
            <BackIcon />
          </button>
          <h2 class="mt-5 mb-5 text-sm sm:text-2xl font-semibold uppercase text-primary">
            {{ $t('summary.customHeading') }}
          </h2>
        </div>
        <div class="flex flex-wrap items-center">
          <div class="border-t border-purple-gray px-4 sm:px-8 lg:px-10 py-6 w-full">
            <div class="flex items-center py-5">
              <PenIcon class="mr-3 w-7 h-7 md:w-9 md:h-9" />
              <div>
                <h3 class="text-base sm:text-lg text-left text-primary font-semibold leading-snug">
                  {{ $t('summary.comment') }}
                </h3>
              </div>
            </div>
            <div class="flex flex-wrap lg:flex-no-wrap items-end">
              <div class="w-full">
                <BaseComment :key="id" />
              </div>
              <div class="lg:ml-4 lg:mr-6 file-upload">
                <FileUploader :key="id" />
              </div>
            </div>
          </div>
        </div>
        <div class="sum flex flex-col items-center">
          <router-link
            :to="{name: 'CONTACT_FORM'}"
            tag="button"
            class="text-xs sm:text-base btn mt-8 mb-4 mx-4 px-6 sm:px-8 md:px-12 py-4 flex items-center animate"
          >
            {{ $t('summary.submitForm') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import BaseComment from '@/components/BaseComment';
import AccountWidget from '@/components/AccountWidget';
import FileUploader from '@/components/FileUploader';
import BackIcon from '@/assets/icons/back.svg';
import PenIcon from '@/assets/icons/pen.svg';

export default {
  name: 'CustomSummary',
  components: {
    AccountWidget,
    BaseComment,
    FileUploader,
    BackIcon,
    PenIcon,
  },
  data() {
    return {
      activeStep: 1,
    };
  },
  computed: {
    ...mapState('order', ['subcategories', 'bonuses', 'orderPrice', 'tastes', 'extras', 'subcategory_id', 'id']),
    ...mapGetters('order', ['chosenCategoryObj']),
    extrasExist() {
      return Object.values(this.extras).reduce((prev, curr) => prev || curr);
    },
  },
  methods: {
    getTaste(id) {
      let result;
      this.chosenCategoryObj.tastes.forEach(
        (el) => {
          if (el.id === id) result = el;
        },
      );

      return result;
    },
  },
};
</script>
